import React from "react";
import * as Scroll from "react-scroll";

export default function CertificateSection(props) {
    return (
        <Scroll.Element name="mba-certificate" className="certificate">
            <div className="content">
                <h2 className="amir-cert-title">اعطای گواهی‌نامه</h2>
                <br/>
                <span className="amir-cert-label">
                            دریافت گواهی نامه معتبر  MBAاز دانشگاه صنعتی امیرکبیر
                        </span>
                <br/><br/><br/><br/>
                <div className="row">
                    <div className="col-xs-12 col-sm-12 text-center">
                         <img
                            src="/images/amirkabir_cert.png"
                            className="amir-cert"
                            alt="logo-amirkabir"
                        />
                    </div>
                </div>
            </div>
        </Scroll.Element>
    );
}
